import type { AppModule } from '@ohmybible/core';

import * as routes from './routes';

export const AuthModule: AppModule = {
  routes,
};
